import { ZodSchema } from "zod";

export const typeMap: Record<string, () => Promise<{ default: ZodSchema }>> = {
  ExpandableList: () =>
    import("../components/ExpandableList/ExpandableListTypes"),
  GraphicSwipe: () => import("../components/GraphicSwipe/GraphicSwipeTypes"),
  VideoPlayer: () => import("../components/VideoPlayer/VideoPlayerTypes"),
  TeaserCounter: () => import("../components/TeaserCounter/TeaserCounterTypes"),
  IncomeTax: () => import("../components/IncomeTax/IncomeTaxTypes"),
  LinkBoxCampaign: () => import("../components/LinkBoxCampaign/LinkBoxCampaignTypes")
};
